// モバイル専用：画面下部固定の連絡アクションバー
import React from 'react';
import { CONTACT } from '../data/services';

function MobileCTA() {
  return (
    <div className="mobile-cta" role="navigation" aria-label="ติดต่อด่วน">
      <a href={CONTACT.phoneHref} className="mobile-cta-phone">
        <span className="material-icons" aria-hidden="true">call</span>
        โทรหาเรา
      </a>
      <a
        href={CONTACT.lineUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="mobile-cta-line"
      >
        <span className="material-icons" aria-hidden="true">chat</span>
        จองคิว LINE
      </a>
    </div>
  );
}

export default MobileCTA;
